import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@components/ui/dialog";
import { cloneElement, useState } from "react";

const CricketDialog = ({ children, title, trigger }: any) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>{trigger}</DialogTrigger>
      <DialogContent className="sm:max-w-[450px]">
        <DialogHeader className="h-fit pt-5">
          <DialogTitle className="text-center pt-4 h-fit border-neutral-200">
            {title}
          </DialogTitle>
        </DialogHeader>

        {cloneElement(children, { setOpen })}
      </DialogContent>
    </Dialog>
  );
};

export default CricketDialog;
